export default "__VITE_ASSET__cf4f6e0c__"